import { styled, Box, StyleSystemProps } from '@withjoy/joykit';

export const StylePillFormField = styled(Box)``;
export const StylePillFormFieldLabel = styled(Box)``;
export const StylePillFormFieldLabelInfo = styled(Box)<{ error?: boolean }>`
  color: ${({ error = false, theme }) => (error ? theme.colors.negative7 : 'inherit')};
  font-weight: ${({ error = false }) => (error ? 'normal' : 'inherit')};
`;

const pillFormFieldLabelStyles: StyleSystemProps = {
  display: 'inline-block',
  marginBottom: 3,
  userSelect: 'none',
};

export const styles = {
  pillFormFieldLabel: pillFormFieldLabelStyles,
};
